import { type FieldConfiguration } from './types';

export function parseCloudId(value: string): Partial<FieldConfiguration> | undefined {
  const trimmed = value.trim();
  return trimmed ? { cloudId: trimmed } : undefined;
}
